// #region imports
import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
// #endregion

const MuiDialogActions = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      gap: 16,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '10px 35px 40px',
      marginTop: 'auto',
      '& > *': {
        maxWidth: 404,
        width: '100%'
      },
      [theme.breakpoints.up('md')]: {
        padding: '8px 35px 54px'
      }
    })
  }
} as Components['MuiDialogActions'];

export default MuiDialogActions;
